module.exports = __webpack_public_path__ + "img/collection-weddingRingsClassic@2x.1eff682.webp";